import { useFetchInstance } from '@/composables/api/useFetchInstance';

export interface SaveResolveResponse {
    type: 'design' | 'order';
    fileUrl: string;
    /** JSON de la sauvegarde renvoyé inline par le backend (évite un fetch S3 côté
     *  navigateur → pas de dépendance CORS pour les domaines export). Peut être null. */
    content?: Record<string, unknown> | null;
    productId: string | null;
}

/**
 * Résolveur unifié de sauvegarde : à partir de l'identifiant porté par ?save={id},
 * le backend détermine s'il s'agit d'un backup (SaveDesign) ou d'une sauvegarde
 * panier (SaveFile) et renvoie l'URL présignée du JSON + le type.
 */
export function useSaves() {
    async function resolveSave(id: string) {
        return await useFetchInstance(`/release/saves/${id}`).get().json<SaveResolveResponse>();
    }

    return { resolveSave };
}
